import { render } from "./CombinedTargetEditorDialog.vue?vue&type=template&id=55fb798a"
import script from "./CombinedTargetEditorDialog.vue?vue&type=script&lang=ts"
export * from "./CombinedTargetEditorDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script